import React, { Component } from 'react';
import MaskBottom from '../../images/main-banner/mask-bottom.svg';
import Strapline from '../../images/main-banner/odisea-strapline.svg';
import BannerCarousel from '../carousel/banner-carousel';

class MainBanner extends Component {
  constructor() {
    super();
    this.state = {
      show: false,
    }
    this.toggleMenu = this.toggleMenu.bind(this);
  }
  toggleMenu() {
    this.setState((menuBlade) => {
      return {
        ...menuBlade,
        show: !menuBlade.show
      }
    })
  }
  render() {
    return (
      <article className='main-banner'>
        <div className='strapline text-align-right'>
          <h1 className='nowrap'>The adventure begins at</h1>
          <img src={Strapline} alt="" />
        </div>
        <section className='waves'>
          <div></div>
          <div></div>
          <div></div>
        </section>
        <img src={MaskBottom} className='mask-bottom' alt="" />
        <BannerCarousel />
      </article>
    );
  }
}

export default MainBanner;
